import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container, createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import PeopleList from './components/PeopleList';
import TreeView from './components/TreeView';
import PersonForm from './components/PersonForm';

const theme = createTheme({
  palette: {
    primary:    { main: '#3e2c1c', contrastText: '#f5ede0' },
    secondary:  { main: '#c8a96e' },
    background: { default: '#f5f0eb', paper: '#ffffff' },
    text:       { primary: '#2c2416', secondary: '#7a6a5a' },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: '0 2px 16px rgba(60,40,20,0.10)' },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { boxShadow: '0 2px 8px rgba(0,0,0,0.25)' },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppBar position="static">
          <Toolbar>
            <Typography
              variant="h6"
              component={Link}
              to="/"
              sx={{ flexGrow: 1, fontWeight: 700, letterSpacing: 1.5, textDecoration: 'none', color: 'inherit' }}
            >
              Genealogía
            </Typography>
          </Toolbar>
        </AppBar>
        <Container sx={{ mt: 4, mb: 6 }}>
          <Routes>
            <Route path="/" element={<PeopleList />} />
            <Route path="/tree/:id" element={<TreeView />} />
            <Route path="/people/new" element={<PersonForm isNew />} />
            <Route path="/people/:id/edit" element={<PersonForm />} />
          </Routes>
        </Container>
      </Router>
    </ThemeProvider>
  );
}

export default App;
